import { Icon } from '@iconify/react/dist/iconify.js';

function EmptyMessageCard({
  icon,
  message,
}: {
  icon: string;
  message: string;
}) {
  return (
    <div className='flex flex-col items-center justify-center p-4 text-gray-400'>
      <Icon icon={icon} width={20} />
      <p className='mt-2 text-sm'>{message}</p>
    </div>
  );
}

export default EmptyMessageCard;
